import { configureStore } from "@reduxjs/toolkit";
import settingsSlice from "./reducers/settingsSlice";
// import AuthReducer from './features/authSlice';

export const store = configureStore({
  reducer: {
    settings: settingsSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
